export default __webpack_public_path__ + "static/media/sweet-video.a9071875.mp4";